import React from 'react';

import { SimpleObject } from '@clearverify/types';

import { Modal } from 'src/components/common';
import { VerifierStaffViewDetailsByClearVerifyStaffModalForm } from 'src/components/verifier';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export interface VerifierStaffDetailsModalArgs extends SimpleObject {
  verifierStaffId: string;
  isAdmin?: boolean;
}

export const VerifierStaffDetailsModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } = useModal<VerifierStaffDetailsModalArgs>(
    ModalId.VerifierStaffDetailsModal,
  );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Staff Details"
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
      maxWidth={600}
      headerPadding="32px 32px 8px 32px"
    >
      <VerifierStaffViewDetailsByClearVerifyStaffModalForm
        verifierStaffId={args?.verifierStaffId}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
        isAdmin={args?.isAdmin || false}
      />
    </Modal>
  );
};
